<script>
import NewModal from "../ui/NewModal.vue";
import ConstructionModal from "./ConstructionModal.vue";
export default {
    name: "ConstructionModalLink",
    components: {ConstructionModal, NewModal},
    props: {
        id: {required: true},
        circling: {required: false, default: () => []}
    },
    data() {
        return {
            ui: {
                showModal: false,
                currentId: this.id
            },
            construction: {}
        }
    },
    methods: {
        showModal() {
            this.ui.showModal = true;
        },
        closeModal() {
            console.log('fecha modal')
            this.ui.showModal = false;
        }
    },
    computed: {
        currentItem() {
            return this.circling.indexOf(this.id)
        }
    }
}
</script>

<template>
    <span>
        <span class="dropdown-trigger" @click.prevent.stop="showModal">
            <slot></slot>
        </span>
        <new-modal :show="ui.showModal" :full-slot="true" width="80%" @close.prevent.stop="closeModal" :wrapper-close="true" @close="closeModal">
            <construction-modal v-if="ui.showModal" :construction-id="ui.currentId" :circling="circling" @close="closeModal"></construction-modal>
        </new-modal>
    </span>
</template>

<style scoped>
.dropdown-trigger {
    display: block;
    padding: 3px 20px;
    clear: both;
    font-weight: 400;
    line-height: 1.42857143;
    color: #333333;
    white-space: nowrap;
    cursor: pointer;
}
.dropdown-trigger:hover,
.dropdown-trigger:focus {
    color: #262626;
    text-decoration: none;
    background-color: #f5f5f5;
}
</style>


// WEBPACK FOOTER //
// ConstructionModalLink.vue?5273af86